import { Point } from 'app/CornerstoneTools/types';
import { Size } from 'app/interfaces/Image';

export default function normalizePoint(dimension: Size, p: Point) {
  return {
    x: p.x / dimension.width,
    y: p.y / dimension.height,
  };
}
